import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getUser: function () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.get('user')
  },
  getUsersListSelect ({
    department = [],
    notUser = '',
    isHrIncluded = false,
    position = []
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        Authorization: `Bearer ${VueCookie.get('token')}`,
        company: VueCookie.get('company')
      }
    })
    const query = []
    if (department.length) query.push(...department)
    if (position.length) query.push(...position)
    if (notUser) query.push(`notUser=${notUser}`)
    if (isHrIncluded) query.push(`isHrIncluded=${isHrIncluded}`)
    return instCred.get(`/user/getSelect?${query.join('&')}`)
  },
  getUserLocation() {
    return axios.get('https://www.iplocate.io/api/lookup');
  },
}



// WEBPACK FOOTER //
// ./src/api/User/api.js